module.exports = __webpack_public_path__ + "static/media/sp37.64d666c8.JPG";